// google-maps-loader.service.ts
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private apiLoaded = false;
  private readonly loadingPromise: Promise<void>;

  constructor(private readonly configService: ConfigService) {
  this.loadingPromise = new Promise((resolve, reject) => {
    if ((window as any).google?.maps) {
      this.apiLoaded = true;
      resolve();
      return;
    }

    if (document.getElementById('googleMapsScript')) {
      return; // Avoid duplicate script loading
    }

    const script = document.createElement('script');
    script.id = 'googleMapsScript';
    script.src = `${this.configService.get('mapUrls').googleMapsBase}?key=${this.configService.get('googleMapsApiKey')}&libraries=places,geometry`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.apiLoaded = true;
      resolve();
    };
   script.onerror = () => {
    reject(new Error('Failed to load script: ' + script.src));
   };

    document.head.appendChild(script);
  });
}

  load(): Promise<void> {
    return this.loadingPromise;
  }
}